import { type DataProvider as RaDataProvider } from 'react-admin'
import simpleRestProvider from 'ra-data-simple-rest'

import { fetchJson, url } from './functions'

export const CognitoDataProvider = (
  partner: string | undefined
): RaDataProvider => ({
  ...simpleRestProvider(url as string, fetchJson(partner))
})
